export default class RegistrationDetailVM {
    registrationStatusId!: number;
    registrationStatusCode!: string;
    registrationStatusName!: string;
    registrationStatusDescription!: string;
}